export type ValidEnvironment = 'local' | 'stage' | 'production'

export function toValidEnvironment(v: unknown): ValidEnvironment {
  if (v === 'local' || v === 'stage' || v === 'production') {
    return v
  }

  throw new Error('Invalid environment: ' + v)
}
